var exports = {
  "k": "xe533113f--3e1dd7--container",
  "K": "xe533113f--3e1dd7--icon",
};

module.exports = exports;
